<template>
  <v-card>
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title style="width: 100%;">
        <v-layout class="pa-0 ma-0" row="row">
          <StatusIndicator class="ma-2" positive="positive" pulse="pulse" v-if="updateInfo"></StatusIndicator>
          <h1 class="subheading">{{ $t('pageHeader.ticketFeedback') }} - 60 Days</h1>
          <v-spacer> </v-spacer>
          <h1 class="subheading">{{ feedbacks.length }}</h1>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="list-350">
      <v-progress-linear v-if="isLoading" size="70" width="7" indeterminate="indeterminate"></v-progress-linear>
      <v-layout column="column" v-if="!isLoading"><template v-for="(row, index) in feedbacks"><v-layout class="pointer"
            @click="viewLocationNewTab(row)" column="column"
            :class="{ red: row.rating == '1', 'lighten-3': row.rating == '1' }"><v-flex class="pb-0"><v-layout><v-flex
                  class="font-weight-medium"><span>
                    <Rating class="mr-1" :rating="row.rating"></Rating>
                  </span><span class="caption list-line">{{ row.Store.CSPID }} - {{ row.Store.businessName }} | {{
                    row.Store.businessPhone | USPhoneNumber }} </span></v-flex><v-spacer></v-spacer><v-flex
                  class="caption text-xs-right" color="text--gray">{{ row.createdAt | moment("from", "now") }}
                </v-flex></v-layout></v-flex><v-flex class="pt-0"><v-layout><v-flex><span class="caption list-line">{{
                  row.feedback }}</span><span class="caption list-line ml-1 red--text" v-if="row.userName">by: {{
    row.userName }} </span></v-flex><v-spacer></v-spacer>
                <v-flex v-if="row.assignedToUser && row.assignedToUser.fullName" class="caption text-xs-right red--text">{{
                  row.assignedToUser.fullName
                }}</v-flex>
                <v-flex v-else class="caption text-xs-right red--text">N/A</v-flex>
              </v-layout></v-flex></v-layout><v-divider v-if="index + 1 &lt; feedbacks.length"
            :key="index"></v-divider></template></v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import ticketService from '../service.js'
import Rating from '../../Tickets/components/TicketRateIcon'
import { StatusIndicator } from 'vue-status-indicator'
// import 'vue-status-indicator/styles.css'

export default {
  data() {
    return {
      feedbacks: [],
      isLoading: true,
      updateInfo: false,
    }
  },
  mounted() {
    this.getAll()
  },
  components: {
    StatusIndicator,
    Rating
  },
  methods: {
    viewLocationNewTab(row) {
      this.$router.push({ path: `/tickets/profile/${row.id}` })
    },
    getAll() {
      return ticketService.getTicketFeedback()
        .then(result => {
          this.feedbacks = result.data
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
